import React, { useState } from 'react';
import '../style.css';

const TexiServices = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [activeFilter, setActiveFilter] = useState('all');

  const taxiServices = [
    {
      id: 1,
      name: "26 Seater Tempo Traveller",
      type: "group",
      seats: 26,
      rating: 4.8,
      image: "https://5.imimg.com/data5/SELLER/Default/2022/10/JN/VY/BO/76895719/26-seater-tempo-traveller-on-rent-500x500.jpg",
      features: [
        { text: "Railway Station Pick/Drop", price: "₹2600" },
        { text: "Airport Pick-up/Drop", price: "₹3200" },
        { text: "Full Day (250 KM min)", price: "₹32/km" },
        { text: "Per Km Rate", price: "₹32/km" }
      ],
      color: "#D4A017",
      badge: "Popular"
    },
    {
      id: 2,
      name: "Force Urbania",
      type: "premium",
      seats: 20,
      rating: 4.9,
      image: "https://cvimg1.cardekho.com/p/630x420/in/force/urbania/force-urbania.jpg?imwidth=480&impolicy=resize",
      features: [
        { text: "Railway Station Pick/Drop", price: "₹2800" },
        { text: "Airport Pick-up/Drop", price: "₹3500" },
        { text: "Full Day (250 KM min)", price: "₹35/km" },
        { text: "Per Km Rate", price: "₹35/km" }
      ],
      color: "#8B4513",
      badge: "Luxury"
    },
    {
      id: 3,
      name: "16 Seater Tempo Traveller",
      type: "group",
      seats: 16,
      rating: 4.7,
      image: "https://www.taxiyatri.com/images/16-seater-tempo-traveller.webp",
      features: [
        { text: "Railway Station Pick/Drop", price: "₹2000" },
        { text: "Airport Pick-up/Drop", price: "₹2500" },
        { text: "Full Day (250 KM min)", price: "₹24/km" },
        { text: "Per Km Rate", price: "₹24/km" }
      ],
      color: "#D4A017"
    },
    {
      id: 4,
      name: "Toyota Innova Crysta",
      type: "premium",
      seats: 7,
      rating: 4.8,
      image: "https://imgd.aeplcdn.com/1280x720/n/cw/ec/51435/innova-crysta-exterior-right-front-three-quarter-3.jpeg?q=85",
      features: [
        { text: "Railway Station Pick/Drop", price: "₹1000" },
        { text: "Airport Pick-up/Drop", price: "₹1800" },
        { text: "Full Day (250 KM min)", price: "₹18/km" },
        { text: "Per Km Rate", price: "₹18/km" }
      ],
      color: "#8B4513",
      badge: "Executive"
    },
    {
      id: 5,
      name: "Maruti Ertiga",
      type: "family",
      seats: 7,
      rating: 4.6,
      image: "https://auto.hindustantimes.com/cms-images/marutisuzuki_ertiga/images/exterior_marutisuzuki-ertiga2022_front-left-side_1150x666.jpeg",
      features: [
        { text: "Railway Station Pick/Drop", price: "₹900" },
        { text: "Airport Pick-up/Drop", price: "₹1400" },
        { text: "Full Day (250 KM min)", price: "₹14/km" },
        { text: "Per Km Rate", price: "₹14/km" }
      ],
      color: "#D4A017"
    },
    {
      id: 6,
      name: "Swift Dzire",
      type: "budget",
      seats: 4,
      rating: 4.5,
      image: "https://www.carandbike.com/_next/image?url=https%3A%2F%2Fimages.carandbike.com%2Fcar-images%2Fgallery%2Fmaruti-suzuki%2F2025-new-dzire%2Fexterior%2Fnew_maruti_suzuki_dzire_front-grill-shot.jpg&w=640&q=75",
      features: [
        { text: "Railway Station Pick/Drop", price: "₹700" },
        { text: "Airport Pick-up/Drop", price: "₹1000" },
        { text: "Full Day (250 KM min)", price: "₹12/km" },
        { text: "Per Km Rate", price: "₹12/km" }
      ],
      color: "#8B4513",
      badge: "Economy"
    }
  ];

  const filters = [
    { id: 'all', label: 'All Vehicles' },
    { id: 'premium', label: 'Premium' },
    { id: 'group', label: 'Group Travel' },
    { id: 'family', label: 'Family' },
    { id: 'budget', label: 'Budget' }
  ];

  const filteredServices = activeFilter === 'all' 
    ? taxiServices 
    : taxiServices.filter(service => service.type === activeFilter);

  return (
    <div className="varanasi-taxi-wrapper">
      {/* Hero Section */}
      <header className="vt-hero-section">
        <div className="vt-hero-container">
          <span className="vt-hero-tag">#1 Taxi Service in Varanasi</span>
          <h1 className="vt-hero-heading">Premium Taxi Services in Varanasi</h1>
          <p className="vt-hero-description">
            Experience luxury, comfort, and reliability with our professional taxi services. 
            Book now for airport transfers, temple tours, or outstation journeys.
          </p>
          
          <div className="vt-hero-features">
            <div className="vt-feature-item">✓ 24/7 Service Available</div>
            <div className="vt-feature-item">✓ Professional Drivers</div>
            <div className="vt-feature-item">✓ Best Price Guarantee</div>
          </div>

          <div className="vt-hero-actions">
            <button className="vt-btn vt-btn-call">Call Now: +91 98765 43210</button>
            <button className="vt-btn vt-btn-whatsapp">WhatsApp Booking</button>
          </div>
        </div>
        
        {/* Stats */}
        <div className="vt-stats-container">
          <div className="vt-stat-card">
            <div className="vt-stat-value">10,000+</div>
            <div className="vt-stat-label">Happy Customers</div>
          </div>
          <div className="vt-stat-card">
            <div className="vt-stat-value">50+</div>
            <div className="vt-stat-label">Fleet Vehicles</div>
          </div>
          <div className="vt-stat-card">
            <div className="vt-stat-value">100+</div>
            <div className="vt-stat-label">Destinations</div>
          </div>
          <div className="vt-stat-card">
            <div className="vt-stat-value">4.8/5</div>
            <div className="vt-stat-label">Customer Rating</div>
          </div>
        </div>
      </header>

      {/* Filter Section */}
      <section className="vt-filter-section">
        <div className="vt-section-header">
          <h2 className="vt-section-title">Choose Your Perfect Ride</h2>
          <p className="vt-section-subtitle">Filter by category to find your ideal vehicle</p>
        </div>
        
        <div className="vt-filter-buttons">
          {filters.map(filter => (
            <button
              key={filter.id}
              className={`vt-filter-btn ${activeFilter === filter.id ? 'vt-filter-active' : ''}`}
              onClick={() => setActiveFilter(filter.id)}
            >
              {filter.label}
            </button>
          ))}
        </div>
      </section>

      {/* Services Grid - 3 Cards per Row */}
      <section className="vt-services-section">
        <div className="vt-services-grid">
          {filteredServices.map((service) => (
            <div
              key={service.id}
              className={`vt-service-card ${hoveredCard === service.id ? 'vt-card-hover' : ''}`}
              onMouseEnter={() => setHoveredCard(service.id)}
              onMouseLeave={() => setHoveredCard(null)}
              style={{ '--vt-accent-color': service.color }}
            >
              {/* Badge */}
              {service.badge && (
                <div className="vt-card-badge" style={{ backgroundColor: service.color }}>
                  {service.badge}
                </div>
              )}

              {/* Image Section */}
              <div className="vt-card-image">
                <img src={service.image} alt={service.name} className="vt-vehicle-image" />
              </div>

              <div className="vt-card-body">
                <div className="vt-card-header">
                  <h3 className="vt-vehicle-name">{service.name}</h3>
                  <div className="vt-vehicle-info">
                    <span className="vt-info-item">{service.seats} Seats</span>
                    <span className="vt-info-item">★ {service.rating}</span>
                  </div>
                </div>

                {/* Features */}
                <div className="vt-card-features">
                  {service.features.map((feature, index) => (
                    <div key={index} className="vt-feature-row">
                      <span className="vt-feature-text">{feature.text}</span>
                      <span className="vt-feature-price">₹ {feature.price}</span>
                    </div>
                  ))}
                </div>

                {/* Action Buttons */}
                <div className="vt-card-actions">
                  <button className="vt-card-btn vt-btn-details">View Details →</button>
                  <button 
                    className="vt-card-btn vt-btn-book"
                    style={{ backgroundColor: service.color }}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="vt-view-more">
          <button className="vt-view-all-btn">
            View All 15+ Taxi Services →
          </button>
        </div>
      </section>

      {/* Features Section */}
      <section className="vt-benefits-section">
        <div className="vt-section-header">
          <h2 className="vt-section-title">Why Choose Our Taxi Service?</h2>
          <p className="vt-section-subtitle">We provide the best travel experience in Varanasi</p>
        </div>
        
        <div className="vt-benefits-grid">
          <div className="vt-benefit-card">
            <div className="vt-benefit-icon" style={{ backgroundColor: '#D4A017' }}></div>
            <h3 className="vt-benefit-title">Expert Drivers</h3>
            <p className="vt-benefit-description">Local experts with 10+ years experience</p>
          </div>
          
          <div className="vt-benefit-card">
            <div className="vt-benefit-icon" style={{ backgroundColor: '#8B4513' }}></div>
            <h3 className="vt-benefit-title">Clean Vehicles</h3>
            <p className="vt-benefit-description">Daily sanitized & well-maintained cars</p>
          </div>
          
          <div className="vt-benefit-card">
            <div className="vt-benefit-icon" style={{ backgroundColor: '#D4A017' }}></div>
            <h3 className="vt-benefit-title">Best Prices</h3>
            <p className="vt-benefit-description">No hidden charges, transparent pricing</p>
          </div>
          
          <div className="vt-benefit-card">
            <div className="vt-benefit-icon" style={{ backgroundColor: '#8B4513' }}></div>
            <h3 className="vt-benefit-title">24/7 Support</h3>
            <p className="vt-benefit-description">Round-the-clock customer support</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="vt-cta-section">
        <div className="vt-cta-container">
          <h2 className="vt-cta-title">Ready to Book Your Ride?</h2>
          <p className="vt-cta-text">
            Get instant confirmation and best prices. Our team is available 24/7 to assist you.
          </p>
          <div className="vt-cta-buttons">
            <button className="vt-btn vt-btn-whatsapp">Book via WhatsApp</button>
            <button className="vt-btn vt-btn-call">Call for Booking</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TexiServices;